import { useEffect } from "react";
import { awsRum } from "../../..";
import { RUMPage } from "../../../enums/rum";
import JogAdminGrid from "../../../components/admin/jogs";

const JogAdminPage = () => {
  useEffect(() => {
    try{
      awsRum.recordPageView(RUMPage.ADMIN);
    }
    catch{
      // Swallow rum errors
    }
    
  }, [])
  
  return <JogAdminGrid />;
};

export default JogAdminPage;
